import {Component} from "@angular/core";
import {Base} from "../../../../../../common/interfaces/base.interfaces";


@Component({
    selector: "section-location-type-list-all",
    template: `
        <section-location-type-list [state]="state"></section-location-type-list>`
})
export class LocationTypeAllComponent implements Base.IComponent {

    public readonly state: Base.IState;

    public constructor() {
    }

    public ngConfig(): Base.IConfig {
        return {
            name: "location-type",
            actions: {
                "browse": ["browse_warehouse_location_types"]
            }
        };
    }

}
